<script setup>
// Kargo Kurtarma kart detayı — Şubede ve Dönüş Yolunda sekmelerinde ortak:
// varyant görselli ürün listesi + sipariş/şube bilgi şeridi + iade geçmişi +
// Kişi Kartı ve İade/Değişim köprüleri.
defineProps({
  item: { type: Object, required: true },
  accountId: { type: [String, Number], required: true },
});

const tl = v => (v || 0).toLocaleString('tr-TR');
const STATUS_TR = {
  refunded: 'iade edildi',
  exchanged: 'değişim yapıldı',
  cancelled: 'iptal',
  code_issued: 'kod verildi',
  received: 'paket geldi',
  awaiting_iban: 'IBAN bekleniyor',
};
</script>

<template>
  <div class="border-t border-n-weak bg-n-solid-2 px-4 py-3">
    <div
      v-for="(line, ix) in item.items || []"
      :key="ix"
      class="flex items-center gap-3 py-2 border-b border-n-weak last:border-0"
    >
      <img
        v-if="line.image"
        :src="line.image"
        class="w-12 h-16 object-cover rounded-md shrink-0"
        loading="lazy"
      />
      <div
        v-else
        class="w-12 h-16 rounded-md bg-n-slate-3 shrink-0 flex items-center justify-center text-n-slate-9"
      >
        🛍️
      </div>
      <div class="min-w-0 flex-1">
        <div class="font-semibold text-n-slate-12 text-sm truncate">
          {{ line.code }}
        </div>
        <div class="text-xs text-n-slate-11">{{ line.variant }}</div>
      </div>
      <div class="text-right shrink-0 text-sm">
        <div class="font-bold text-n-slate-12">× {{ line.qty }}</div>
        <div v-if="line.price" class="text-n-slate-11">
          {{ tl(line.price) }} ₺
        </div>
      </div>
    </div>
    <div
      v-if="!item.items || !item.items.length"
      class="text-sm text-n-slate-10 py-2"
    >
      Sipariş kalemi bulunamadı (takip no: {{ item.tracking_no }})
    </div>

    <div
      class="grid grid-cols-2 md:grid-cols-3 gap-x-4 gap-y-1 text-xs text-n-slate-11 border-t border-n-weak mt-1 pt-2"
    >
      <div>
        <span class="text-n-slate-10">Sipariş:</span>
        {{ item.order_number || '—' }} ·
        {{ item.channel === 'ticimax' ? 'Koza' : 'ModaX' }}
      </div>
      <div>
        <span class="text-n-slate-10">Tarih:</span>
        {{ item.ordered_on || '—' }}
      </div>
      <div>
        <span class="text-n-slate-10">Şube tel:</span>
        {{ item.branch_phone || '—' }}
      </div>
    </div>

    <div
      v-if="item.return_history && item.return_history.length"
      class="text-xs text-n-slate-11 border-t border-n-weak mt-2 pt-2"
    >
      <span class="font-bold text-n-slate-12">↩️ İade geçmişi:</span>
      <span v-for="h in item.return_history" :key="h.code" class="mr-2">
        {{ h.code }} ({{ h.on }} · {{ STATUS_TR[h.status] || h.status }})
      </span>
    </div>

    <div class="flex flex-wrap gap-2 mt-3">
      <router-link
        v-if="item.contact_id"
        :to="`/app/accounts/${accountId}/contacts/${item.contact_id}`"
        class="px-4 py-2 rounded-lg bg-n-slate-12 text-white font-bold text-sm"
      >
        👤 Kişi Kartı
      </router-link>
      <router-link
        :to="{
          name: 'return_center',
          query: { siparis: item.order_number || item.tracking_no },
        }"
        class="px-4 py-2 rounded-lg bg-woot-600 text-white font-bold text-sm"
      >
        ↩️ İade/Değişim'de aç
      </router-link>
    </div>
  </div>
</template>
